import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  dates: [],
  message: '',
}

const datesSlicer = createSlice({
  name: 'dates',
  initialState,
  reducers: {
    getPossibleDatesRequest(state) {
      state.loading = true
    },
    getPossibleDatesSuccess(state, { payload }) {
      state.loading = false
      state.dates = payload.dates

      state.message = payload.message
    },
    getPossibleDatesFailure(state) {
      state.loading = false
    },
  },
})

export const {
  getPossibleDatesFailure,
  getPossibleDatesRequest,
  getPossibleDatesSuccess,
} = datesSlicer.actions

export default datesSlicer.reducer
